
import { Component, Vue } from 'vue-property-decorator'
import SearchNav from '@/views/industryMall/shop/template/SearchNav.vue'
import {
  clearSearchHistory,
  getSearchHistoryList as a,
  SearchHistoryDto
} from '@/api/shoppingMall'
import {
  getStoreSearchHistoryList,
  clearStoreSearchHistory,
  addStoreSearchHistory
} from '@/api/industryMall'
import { Getter } from 'vuex-class'

@Component({
  name: 'ShopSearchHistory',
  components: { SearchNav }
})
export default class ShopSearchHistory extends Vue {
  @Getter companyId!: string
  @Getter partnerCompanyId!: string
  private historyList: Array<SearchHistoryDto> = []
  searchType = '' // 1：店铺搜索 3：店铺商品搜索
  placeHolder = ''

  params = {
    searchType: '',
    storeId: '',
    pageIndex: 1,
    pageSize: 20
  }

  created() {
    this.searchType = this.$route.query.searchType as string
    if (this.searchType === '1') {
      this.placeHolder = '请输入商品或店铺名称'
      this.params.storeId = this.partnerCompanyId
    } else if (this.searchType === '3') {
      this.placeHolder = '请输入商品名称'
      this.params.storeId = this.$route.query.storeId as string
    }
    this.getHistoryList()
  }
  activated() {
    console.log('缓存调用');
    this.getHistoryList()
  }
  close() {
    console.log('123')
  }

  /**
   * 获取历史搜索记录
   */
  getHistoryList() {
    console.log('providerId', this.partnerCompanyId)
    this.params.searchType = this.searchType

    const params = { ...this.params }
    console.log('params', params)
    getStoreSearchHistoryList(params).then((res) => {
      this.historyList = res.data.records
    })
  }

  clearFunc() {
    let params = {
      searchType: this.searchType, // 1：店铺搜索 2:折扣搜索 3：店铺商品搜索
      // autoId:'', // 不传清空所有
      storeId: this.partnerCompanyId
    }
    clearStoreSearchHistory(params)
      .then(() => {
        this.$toast({ message: '已清除' })
        this.getHistoryList()
      })
      .catch(() => {})
  }

  toSearchShop(keyword: string) {
    if (this.searchType === '1') {
      this.$router.push({
        // path: '/MallSearchShop',
        path: '/SearchCategoryGoods',
        query: {
          keyword: keyword
        }
      })
    } else if (this.searchType === '3') {
      // 店铺内部搜索
      this.$router.push({
        path: '/MallSearchGoods',
        query: {
          keyword: keyword,
          storeId: this.$route.query.storeId
        }
      })
    }
  }
}
